import { render } from "./Sidebar.vue?vue&type=template&id=1c77465f"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\saidd\\OneDrive\\Desktop\\AKSA\\Projekti\\udruzenje pravobranilaca\\Admin\\vue-notus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__